/**
 * 1.6.0 site services: the data hooks (docs/dev/mcp-1.6.0-build.md). Step 0 wrote them against W's routes (the stub
 * lists no agents; Test answers 501); stream W owns this file now.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { AgentSiteServicesDTO, SiteServiceTestResult } from '@prism/contracts';
import { api } from '../client';
import { queryKeys } from '../queryKeys';

/** Every agent's gateway and services (automation.manage). */
export function useSiteServices(enabled = true) {
  return useQuery({ queryKey: queryKeys.siteServices(), queryFn: () => api<{ items: AgentSiteServicesDTO[] }>('/api/v1/site-services'), enabled, staleTime: 15_000 });
}

/** Test one service through its agent (admin): a HEAD or GET of its health path. */
export function useTestSiteService() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ agentId, service }: { agentId: string; service: string }) =>
      api<SiteServiceTestResult>(`/api/v1/site-services/${agentId}/${encodeURIComponent(service)}/test`, { method: 'POST', json: {} }),
    onSettled: () => { void qc.invalidateQueries({ queryKey: queryKeys.siteServices() }); },
  });
}
